import React from 'react';
import propTypes from 'prop-types';

export const SeniorIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      viewBox="-96 0 512 512"
      version="1.1"
      className={variant}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M264,288c-30.928,0 -56,25.072 -56,56l0,38.25c0,8.837 7.163,16 16,16c8.837,0 16,-7.163 16,-16l0,-38.25c0,-13.255 10.745,-24 24,-24c13.255,0 24,10.745 24,24l0,152c0,8.837 7.163,16 16,16c8.837,0 16,-7.163 16,-16l0,-152c0,-30.928 -25.072,-56 -56,-56Zm-133.257,-175.437c12.189,0.75 20.568,6.001 25.139,15.752l44.827,83.406l79.784,9.066c14.116,1.604 24.259,14.347 22.655,28.463c-1.607,14.142 -14.394,24.291 -28.532,22.646l-93.616,-10.896c-4,-0.5 -10.596,-2.633 -15.262,-6.384c-4.666,-3.751 -9.284,-8.392 -13.855,-13.924c-4.571,-5.532 -8.38,-10.455 -11.427,-14.768c-3.047,-4.313 -6.809,-9.939 -11.284,-16.878c-4.476,-6.938 -7.57,-11.626 -9.284,-14.064l-31.424,82.138l11.998,69.76c1.714,7.689 2.571,12.94 2.571,15.753c0,2.813 -0.762,7.782 -2.285,14.909l-25.425,109.423c-4.19,16.69 -17.617,25.035 -40.28,25.035c-9.522,-0.188 -17.188,-4.219 -22.996,-12.096c-5.809,-7.876 -7.856,-16.69 -6.142,-26.441l21.425,-114.206l-17.712,-75.668c-8.379,-18.753 -11.284,-37.881 -8.713,-57.384c2.571,-19.503 9.666,-38.349 21.283,-56.54c24.187,-37.506 51.421,-56.727 81.702,-57.665c13.331,0 22.282,0.188 26.853,0.563Zm109.257,-56.563c0,30.928 -25.072,56 -56,56c-30.928,0 -56,-25.072 -56,-56c0,-30.928 25.072,-56 56,-56c30.928,0 56,25.072 56,56Z"
      ></path>
    </svg>
  );
};
SeniorIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
SeniorIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
